<template>
    <div class="unit-settings-table__new-row">
        <CompassButton
            :label="$t.__('settings.units.unit_list.new_button')"
            leftIcon="plus"
            type="tertiary"
            @click="addUnit"
        />
    </div>
</template>
<script>
export default {
    methods: {
        addUnit() {
            this.$emit('addUnit');
        },
    },
};
</script>
<style lang="scss" scoped>
.unit-settings-table__new-row {
    border-bottom: 1px solid var(--colors-common-border-lighter);
    padding: var(--spacing-2) var(--spacing-3);
}
</style>
